module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_vm._v("What came of that mystical wedding, of the world we know and the world we do not know, by that rose of the spirit, committed thus in so great a hope, so great a faith? The Druid is not here to tell. Faith after Faith has withered like a leaf. But still we stand by ancestral altars, still offer the Rose of Desire to the veiled Mystery, still commit this our symbol to the fathomless, the everlasting, the unanswered Deep.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARP")]), _vm._v(", from "), _c('i', [_vm._v("Where the Forest Murmurs")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pxxiv-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c82dc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_epigraph.vue
// module id = 78
// module chunks = 0